import AutoCompleteFilter from "../../../../components/AutoCompleteFilter";
import baseService from "../../../../services/baseService";

export const inputsFiltersProducts = ({ localFilterValues, handleFilterChange }) => [
    {
      label: "Nome",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="name"
          model="product"
          value={localFilterValues.name}
          onChange={(selected) => handleFilterChange("name", selected)}
          placeholder="Filtre os produtos pelo nome"
          isMulti
          isClearable
        />
      ),
    },
    {
      label: "Condição",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="name"
          model="condition"
          value={localFilterValues['items.condition.name']}
          onChange={(selected) => handleFilterChange("items.condition.name", selected)}
          placeholder="Filtre os produtos pela condição"
          isMulti
          isClearable
        />
      ),
    },
    {
      label: "Categoria",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="name"
          model="category"
          value={localFilterValues['items.category.name']}
          onChange={(selected) => handleFilterChange("items.category.name", selected)}
          placeholder="Filtre os produtos pela categoria"
          isMulti
          isClearable
        />
      ),
    },
    {
      label: "Apelido do Endereço",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="alias"
          model="address" // O modelo ainda é 'address'
          value={localFilterValues['items.address.alias']}
          onChange={(selected) => handleFilterChange("items.address.alias", selected)}
          placeholder="Filtre pelo apelido do endereço"
          isMulti
          isClearable
        />
      ),
    },
    {
      label: "Endereço",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="street"
          model="address"
          value={localFilterValues['items.address.street']}
          onChange={(selected) => handleFilterChange("items.address.street", selected)}
          placeholder="Filtre pela rua do endereço"
          isMulti
          isClearable
        />
      ),
    },
    {
      label: "Cidade",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="city"
          model="address"
          value={localFilterValues['items.address.city']}
          onChange={(selected) => handleFilterChange("items.address.city", selected)}
          placeholder="Filtre pela cidade do endereço"
          isMulti
          isClearable
        />
      ),
    },
    {
      label: "Estado",
      component: (
        <AutoCompleteFilter
          service={baseService}
          columnDataBase="state"
          model="address"
          value={localFilterValues['items.address.state']}
          onChange={(selected) => handleFilterChange("items.address.state", selected)}
          placeholder="Filtre pelo estado do endereço"
          isMulti
          isClearable
        />
      ),
    },
];
    